<script setup>
import { GraduationCap, Users, CircleCheck } from 'lucide-vue-next'

const studentBenefits = [
  {
    title: 'Learn consistently with the same tutor',
    description: 'Build a strong relationship and see real progress over time'
  },
  {
    title: 'Get help beyond the lesson, not just during it',
    description: 'Message your tutor anytime and access support when you need it'
  },
  {
    title: 'Revise using tutor-created content',
    description: 'Access recordings aligned to your course and exam board'
  }
]

const parentBenefits = [
  {
    title: 'Predictable weekly learning and clear pricing',
    description: 'Know exactly what you\'re paying with transparent fees'
  },
  {
    title: 'No more chasing tutors or rescheduling',
    description: 'Weekly structure keeps learning consistent and reliable'
  },
  {
    title: 'Visibility into what your child is learning',
    description: 'Track progress, access content, and stay informed'
  }
]
</script>

<template>
  <section class="py-12 md:py-24 bg-gray-50">
    <div class="max-w-7xl mx-auto px-4 md:px-8">
      <div class="text-center mb-8 md:mb-16">
        <h2 class="text-3xl md:text-4xl md:text-5xl font-bold text-gray-900 mb-4">Who Bindle is for</h2>
        <p class="text-lg md:text-xl text-gray-600">Supporting students and families throughout their learning journey</p>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-12">
        <!-- For Students -->
        <div class="bg-white rounded-3xl p-6 md:p-12 shadow-lg">
          <div class="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center mb-6">
            <GraduationCap class="text-blue-600 w-8 h-8" />
          </div>
          <h3 class="text-2xl md:text-3xl font-bold text-gray-900 mb-6">For students</h3>
          <div class="space-y-5">
            <div
              v-for="(benefit, index) in studentBenefits"
              :key="index"
              class="flex items-start space-x-4"
            >
              <CircleCheck class="text-blue-600 w-6 h-6 md:mt-1 shrink-0" />
              <div>
                <p class="text-sm md:text-lg md:font-semibold text-gray-900 mb-1">{{ benefit.title }}</p>
                <p class="hidden md:block  text-gray-600">{{ benefit.description }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- For Parents -->
        <div class="bg-white rounded-3xl p-6 md:p-12 shadow-lg">
          <div class="w-16 h-16 bg-purple-100 rounded-2xl flex items-center justify-center mb-6">
            <Users class="text-purple-600 w-8 h-8" />
          </div>
          <h3 class="text-2xl md:text-3xl font-bold text-gray-900 mb-6">For parents</h3>
          <div class="space-y-5">
            <div
              v-for="(benefit, index) in parentBenefits"
              :key="index"
              class="flex items-start space-x-4"
            >
              <CircleCheck class="text-purple-600 w-6 h-6 mt-1 shrink-0" />
              <div>
                <p class="text-sm md:text-lg md:font-semibold text-gray-900 mb-1">{{ benefit.title }}</p>
                <p class="hidden md:block text-gray-600">{{ benefit.description }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
